// parse the raw contentful object as in: const newMessage = JSON.parse(thankYouMessage.raw);
// then pass "newMessage.content" as the argument "contentfulContentObj"

export const findIndexOfRichTextTag = (target, contentfulContentObj) =>
  contentfulContentObj.findIndex((item) =>
    item.content?.some(({ value }) => value?.includes(target))
  );

export const replaceRichTextTags = (richText, replacements) => {
  // Check if richText is null or undefined
  if (!richText) {
    console.error('Rich Text is null or undefined');
    return;
  }

  // Check if richText.raw is null or empty
  if (!richText.raw || richText.raw.trim() === '') {
    console.error('Rich Text Raw is null or empty');
    return;
  }

  replacements.forEach(({ tag, replacement }) => {
    if (typeof replacement === 'object' || !replacement) {
      // whole paragraph replacement
      const newMessageObj = JSON.parse(richText.raw);
      // Find {{tag}} in RichText and replace with the message provided
      const targetIndex = findIndexOfRichTextTag(tag, newMessageObj.content);
      // if {{tag}} found, delete 1 item, otherwise, insert it (deleteCount = 0)
      const deleteCount = targetIndex >= 0 ? 1 : 0;

      if (targetIndex >= 0 && replacement) {
        // if {{tag}} found, replace it with replacement
        newMessageObj.content.splice(targetIndex, deleteCount, replacement);
      } else {
        // if {{tag}} found but replacement empty, remove {{tag}}: splice(targetIndex, 1)
        // if {{tag}} not found, splice will do nothing: splice(-1,0)
        newMessageObj.content.splice(targetIndex, deleteCount);
      }
      richText.raw = JSON.stringify(newMessageObj);
    } else if (typeof replacement === 'string') {
      // inline string replacement
      richText.raw = richText.raw.replace(tag, replacement);
    }
  });
};
